import React, { FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import { TopPerformerProps } from '../../Card'
import BodyFont from '../../../../Theme/Fonts/Body'
import SmallBodyFont from '../../../../Theme/Fonts/SmallBody'
import NonFlexingContainer from '../../../../Layouts/NonFlexingContainer'
import FlagImage from '../../../../BaseComponents/Image/Flag'
import PlayerImage from '../../../../BaseComponents/Image/Player'

type TopPerformerBigProps = {
    /**
     * performer to render
     * */
    performer: TopPerformerProps
    /**
     * action called when pressed on the performer
     * @TJS-type function
     */
    onPress?: () => void
}

const TopPerformerBig: FunctionComponent<TopPerformerBigProps> = ({ performer, onPress }) => {
    const { lastname, firstname, team, unit, imageUrl, imageType, alt, value } = performer
    return (
        <Touchable onPress={onPress}>
            <Grid
                noExpand
                horizontal
                centerVertical
                paddingY={4}
                paddingX={5}
                backgroundColor="pearl"
            >
                <Grid paddingRight={3} minWidth={0}>
                    <BodyFont numberOfLines={1} bold>
                        {`${lastname}, ${firstname}`}
                    </BodyFont>
                    {team ? (
                        <SmallBodyFont numberOfLines={1} color="onyx-4">
                            {team}
                        </SmallBodyFont>
                    ) : null}
                    <Grid horizontal>
                        <NonFlexingContainer marginRight={2}>
                            <SmallBodyFont bold>{`${value}`}</SmallBodyFont>
                        </NonFlexingContainer>
                        <SmallBodyFont color="keshi-4">{unit}</SmallBodyFont>
                    </Grid>
                </Grid>

                {imageType === 'FLAG' ? (
                    <FlagImage width={44} imageUrl={imageUrl} alt={alt} size="M" />
                ) : (
                    <PlayerImage width={58} imageUrl={imageUrl} alt={alt} size="M" />
                )}
            </Grid>
        </Touchable>
    )
}
export default TopPerformerBig
